import { SITE_FOR_MAPVIEW } from '@/types/site'
import { STATION_DETAIL } from '@/types/stations'

export const initialState: WeatherDashboardState = {
  stations: [],
  siteData: [],
  isLoading: false,
  isLoadingSite: false,
}

export interface WeatherDashboardState {
  stations: STATION_DETAIL[]
  siteData: SITE_FOR_MAPVIEW[]
  isLoading: boolean
  isLoadingSite: boolean
}
